/** Még el nem készült képernyők helye. */
export function Hamarosan({ cimke, blokk }: { cimke: string; blokk: number }) {
  return (
    <div className="dayhead" style={{ borderBottom: 'none' }}>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600 }}>{cimke}</div>
        <div className="halvany" style={{ marginTop: 6 }}>
          Ez a képernyő a {blokk}. blokkban készül el.
        </div>
      </div>
    </div>
  );
}
